document.addEventListener('DOMContentLoaded', () => {
  const countrySelect = document.getElementById('country-select');
  const dropdownArrow = countrySelect ? countrySelect.querySelector('.dropdown-arrow') : null;
  const dropdownSelected = countrySelect ? countrySelect.querySelector('.dropdown-selected') : null;
  const dropdownValue = countrySelect ? countrySelect.querySelector('.dropdown-value') : null;
  const dropdownOptions = countrySelect ? countrySelect.querySelector('.dropdown-options') : null;
  const storeItems = document.querySelectorAll('.store-item');
  const defaultImage = document.querySelector('.default-image');
  const countryImages = document.querySelectorAll('.country-specific-image');
  const storeHoverImages = document.querySelectorAll('.store-hover-image');
  const appointmentContainer = document.querySelector('.appointment-container');
  const appointmentButton = document.querySelector('.appointment-button');
  const defaultAppointmentLink = appointmentButton ? appointmentButton.getAttribute('href') : '';

  if (!countrySelect || storeItems.length === 0) return;

  // Custom dropdown functionality
  const toggleDropdown = () => {
    const isOpen = countrySelect.classList.contains('open');
    countrySelect.classList.toggle('open');
    dropdownOptions.style.display = isOpen ? 'none' : 'block';
  };

  const selectOption = (option) => {
    const value = option.getAttribute('data-value');
    const text = option.textContent;

    // Update selected display
    dropdownSelected.textContent = text;
    dropdownValue.value = value;

    // Update selected state
    dropdownOptions.querySelectorAll('.dropdown-option').forEach(opt => {
      opt.classList.remove('selected');
    });
    option.classList.add('selected');

    // Close dropdown
    countrySelect.classList.remove('open');
    dropdownOptions.style.display = 'none';

    // Trigger filter update
    filterStores(value);

    // Adjust dropdown width
    adjustSelectWidth();
  };

  // Event listeners for custom dropdown
  if (countrySelect) {
    countrySelect.addEventListener('click', (e) => {
      // Only toggle if we're not clicking on an option inside the dropdown
      if (!e.target.classList.contains('dropdown-option')) {
        e.stopPropagation();
        toggleDropdown();
      }
    });
  }

  if (dropdownOptions) {
    dropdownOptions.addEventListener('click', (e) => {
      if (e.target.classList.contains('dropdown-option')) {
        selectOption(e.target);
      }
    });
  }

  // Close dropdown when clicking outside
  document.addEventListener('click', (e) => {
    if (!countrySelect.contains(e.target)) {
      countrySelect.classList.remove('open');
      dropdownOptions.style.display = 'none';
    }
  });

  // Keyboard support
  countrySelect.addEventListener('keydown', (e) => {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      toggleDropdown();
    } else if (e.key === 'Escape') {
      countrySelect.classList.remove('open');
      dropdownOptions.style.display = 'none';
    }
  });

  // Hide appointment container on initial load
  if (appointmentContainer) {
    appointmentContainer.style.display = 'none';
  }

  // Pure function to determine store visibility based on country
  const shouldShowStore = (storeCountry, selectedCountry) =>
    selectedCountry === 'all' || storeCountry === selectedCountry;

  // Pure function to update appointment link based on country
  const updateAppointmentLink = (country) => {
    if (!appointmentButton) return;

    // Reset to default link if no country selected or 'all' selected
    if (country === 'none' || country === 'all') {
      appointmentButton.setAttribute('href', defaultAppointmentLink);
      return;
    }

    // Find the country-specific appointment link from the country blocks
    const countryBlock = Array.from(countryImages).find(img => img.dataset.country === country);
    if (countryBlock && countryBlock.dataset.appointmentLink) {
      appointmentButton.setAttribute('href', countryBlock.dataset.appointmentLink);
    } else {
      // Fallback to default link if no country-specific link found
      appointmentButton.setAttribute('href', defaultAppointmentLink);
    }
  };

  // Pure function to filter stores
  const filterStores = (country) => {
    // Hide all stores initially or when 'none' is selected
    if (country === 'none') {
      Array.from(storeItems).forEach(item => {
        item.style.display = 'none';
      });

      // Hide appointment container when no country is selected
      if (appointmentContainer) {
        appointmentContainer.style.display = 'none';
      }
    } else {
      // Show stores based on country selection using functional approach
      Array.from(storeItems).forEach(item => {
        item.style.display = shouldShowStore(item.dataset.country, country) ? 'flex' : 'none';
      });

      // Show appointment container when a country is selected
      if (appointmentContainer) {
        appointmentContainer.style.display = 'inline-flex';
      }
    }

    // Update the appointment link based on country selection
    updateAppointmentLink(country);

    // Update the displayed image based on country selection
    updateCountryImage(country);
  };

  // Pure function to set image visibility
  const setImageVisibility = (img, isVisible, delay = 0) => {
    if (isVisible) {
      img.style.display = 'block';
      setTimeout(() => {
        img.style.opacity = '1';
      }, delay);
    } else {
      img.style.opacity = '0';
      setTimeout(() => {
        if (img.style.opacity === '0') {
          img.style.display = 'none';
        }
      }, 400); // Match transition duration
    }
  };

  // Function to update country image
  const updateCountryImage = (country) => {
    // First set all images to invisible but keep them in the layout
    Array.from(countryImages).forEach(img => {
      setImageVisibility(img, false);
    });

    // Hide all store hover images
    Array.from(storeHoverImages).forEach(img => {
      setImageVisibility(img, false);
    });

    // Show default image if no country is selected or no matching country image
    let matchFound = false;

    if (country !== 'none' && country !== 'all') {
      // Try to find a matching country image
      Array.from(countryImages).forEach(img => {
        if (img.dataset.country === country) {
          setImageVisibility(img, true, 10);
          matchFound = true;

          // Hide default image when showing country-specific image
          if (defaultImage) {
            setImageVisibility(defaultImage, false);
          }
        }
      });
    }

    // If no match was found or 'all'/'none' was selected, show the default image
    if (!matchFound && defaultImage) {
      setImageVisibility(defaultImage, true, 10);
    }
  };

  // Function to handle store item hover
  const handleStoreHover = (storeId, isHovering) => {
    const currentCountry = countrySelect.value;
    const activeCountryImage = Array.from(countryImages).find(img =>
      img.dataset.country === currentCountry && window.getComputedStyle(img).display !== 'none');

    // Find the hover image for this store
    const hoverImage = Array.from(storeHoverImages).find(img =>
      img.dataset.storeId === storeId);

    if (hoverImage) {
      setImageVisibility(hoverImage, isHovering, 10);

      // Handle the default or country image visibility
      if (activeCountryImage) {
        setImageVisibility(activeCountryImage, !isHovering);
      } else if (defaultImage && (currentCountry === 'none' || currentCountry === 'all')) {
        setImageVisibility(defaultImage, !isHovering);
      }
    }
  };

  // When mouse leaves, ensure we show the correct country image
  Array.from(storeItems).forEach(item => {
    item.addEventListener('mouseenter', () => {
      handleStoreHover(item.dataset.storeId, true);
    });

    item.addEventListener('mouseleave', () => {
      handleStoreHover(item.dataset.storeId, false);

      // Make sure the correct country image is shown after hover
      const currentCountry = countrySelect.value;
      if (currentCountry !== 'none' && currentCountry !== 'all') {
        // Find and show the country-specific image
        const countryImage = Array.from(countryImages).find(img =>
          img.dataset.country === currentCountry);

        if (countryImage) {
          setImageVisibility(countryImage, true, 10);
          if (defaultImage) {
            setImageVisibility(defaultImage, false);
          }
        }
      } else {
        // Show default image if no country is selected
        if (defaultImage) {
          setImageVisibility(defaultImage, true, 10);
        }
      }
    });
  });

  // Initialize with the default selection (which should be 'none')
  filterStores(dropdownValue ? dropdownValue.value : 'none');

  window.addEventListener('pageshow', function (e) {
    filterStores(dropdownValue ? dropdownValue.value : 'none');
  });

  // Dynamic width for select dropdown
  const adjustSelectWidth = () => {
    if (!dropdownSelected) return;

    // Create a temporary span to measure text width
    const tempSpan = document.createElement('span');
    tempSpan.style.visibility = 'hidden';
    tempSpan.style.position = 'absolute';
    tempSpan.style.fontSize = '12px';
    tempSpan.style.letterSpacing = '0.5px';
    tempSpan.style.textTransform = 'uppercase';
    tempSpan.style.fontWeight = '400';
    tempSpan.style.fontFamily = getComputedStyle(dropdownSelected).fontFamily;
    tempSpan.textContent = dropdownSelected.textContent;

    document.body.appendChild(tempSpan);
    const textWidth = tempSpan.getBoundingClientRect().width;
    document.body.removeChild(tempSpan);

    // Add some padding to the width
    const calculatedWidth = textWidth + 18; // Increased padding for arrow
    countrySelect.style.width = calculatedWidth + 'px';
  };

  // Adjust width on page load
  adjustSelectWidth();
}); 